import _ from "lodash";
import TableReportHelper from "report/helper";

export default async function apontamentoColetasLocalizacaoReport(

    visita,
    indicador,
    apontamento,
    extraTitles = [],
    extraColsCallback,
    extraColsWidths,
    showObservacao = true
) {
    if (_.isEmpty(apontamento.coletas)) {
        return null;
    }

    const h = new TableReportHelper(apontamento);

    function extraRows(helper) {
        return extraColsCallback ? extraColsCallback(helper) : [];
    }

    const content = [
        h.panel([
            // prettier-ignore
            h.row(
                h.title("COLETAS")
            ),
        ]),
    ];

    let titleArColetasContent = []
    let tamArColetasContent = []

    titleArColetasContent.push(h.title("Foto"))
    tamArColetasContent.push("auto")

    if (showObservacao) {
        titleArColetasContent.push(h.title("Observação"))
        tamArColetasContent.push("*")
    }

    const coletasContent = [
        // prettier-ignore
        h.row(
            ...extraTitles.map((content) => h.title(content)),
            ...titleArColetasContent,
        ),
    ];

    for (const coleta of apontamento.coletas) {
        const r = h.helper(coleta);
        let valueArColetasContent = []
        valueArColetasContent.push(r.imageField("image.base64", { fit: [130, 130], }))
        if (showObservacao) {
            valueArColetasContent.push(r.textField("observacao"))
        }

        coletasContent.push(
            h.row(
                ...extraRows(r),
                ...valueArColetasContent,
            )
        );
    }

    // extraColsWidths ||= extraTitles.map(() => "*");
    extraColsWidths = extraColsWidths || extraTitles.map(() => "*");
    content.push(h.panel(coletasContent, { widths: [...extraColsWidths, ...tamArColetasContent] }));

    return content;
}
